import React, { useEffect } from 'react';

import { Box, Button, Divider, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ReactHookFormSelect from 'common/components/form/ReactHookFormSelect';

import * as actions from '../actions';
import * as selectors from '../selectors';

const ChangeStatusForm = ({ filterData, initialValues, save, statusList }) => {
    const { t } = useTranslation();

    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        mode: 'onChange',
    });

    useEffect(() => reset(initialValues), [initialValues]);

    const handleOnClickSave = (values) => save(filterData, values);

    const options = [
        { disabled: true, label: t('Select a status'), value: '' },
        ...statusList,
    ];

    return (
        <Stack component="form" onSubmit={handleSubmit(handleOnClickSave)}>
            <ReactHookFormSelect
                control={control}
                name="status"
                options={options}
                label=""
            />

            <Divider sx={{ mx: (theme) => `${theme.spacing(-2)}!important` }} />

            <Box sx={{ textAlign: 'right' }}>
                <Button type="submit">{t('Save')}</Button>
            </Box>
        </Stack>
    );
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialChangeStatusValues,
});

const mapDispatchToProps = (dispatch) => ({
    save: (filterData, values) =>
        dispatch(actions.bulkChangeStatus(filterData, values)),
});

ChangeStatusForm.propTypes = {
    filterData: PropTypes.object,
    initialValues: PropTypes.object,
    save: PropTypes.func,
    statusList: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeStatusForm);
